import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatdate',
    standalone: false
})
export class FormatdatePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if (value) {
      return value.toString().replace(/\s/g, "T");
    }

    return null;
  }

}
